import { Controller } from 'stimulus';
import 'blueimp-canvas-to-blob';
import DirectUploader from '../lib/direct_uploader';
import { loadImageAsync, resizeImage } from '../lib/image';

export default class extends Controller {
  static targets = [
    'originInput',
    'input',
    'alert',
    'canvas',
    'fileInput',
    'clearButton',
  ];

  originInputTargetConnected(el) {
    this.fileInputTargets.forEach((input) => {
      input.name = el.name;
    });
    this.clearPreview();
  }

  change(event) {
    const files = Array.from(event.target.files);

    if (files.length === 0) return;

    if (files.length > 3) {
      this.alertTarget.classList.remove('d-none');
      return;
    } else {
      this.alertTarget.classList.add('d-none');
    }

    this.clearButtonTarget.classList.remove('d-none');

    try {
      files.forEach(async (file, index) => {
        if (file.type.includes('image')) {
          await this.uploadImage(file, index);
        } else {
          await this.upload(file, index);
        }
      });
    } catch (error) {
      console.error(error);
    }
  }

  clear() {
    this.clearPreview();
    this.alertTarget.classList.add('d-none');
    this.clearButtonTarget.classList.add('d-none');
    this.inputTarget.value = '';
  }

  async uploadImage(file, index) {
    try {
      // 画像をリサイズする（最大幅と高さを1980pxに設定）
      const resizedFile = await resizeImage(file, 1980, 1980);

      // リサイズした画像をプレビュー表示
      const image = await loadImageAsync(URL.createObjectURL(resizedFile));
      const canvas = this.canvasTargets[index];
      canvas.width = image.width;
      canvas.height = image.height;
      canvas.getContext('2d').drawImage(image, 0, 0, image.width, image.height);
      canvas.classList.remove('d-none');

      // リサイズした画像をアップロード
      await this.upload(resizedFile, index);
    } catch (error) {
      console.error('画像のリサイズに失敗しました:', error);
      // エラーが発生した場合は、元のファイルをそのままアップロード
      await this.upload(file, index);
    }
  }

  async upload(blob, index) {
    const uploadUrl = this.originInputTarget.dataset.directUploadUrl;
    const uploader = new DirectUploader(blob, uploadUrl);
    const result = await uploader.upload();
    this.fileInputTargets[index].value = result.signed_id;
  }

  clearPreview() {
    this.fileInputTargets.forEach((input) => {
      input.value = '';
    });
    this.canvasTargets.forEach((canvas) => {
      canvas.getContext('2d').clearRect(0, 0, canvas.width, canvas.height);
      canvas.classList.add('d-none');
    });
  }
}
